import React, { Component } from 'react'
import { brandStyles, drawDate, logoNode, moneyCents } from './V2Helpers'
import V2PoweredBy from './V2PoweredBy'

const API_ENDPOINT = "https://ay4op9wl42.execute-api.ap-southeast-2.amazonaws.com/Prod/"

class V2ClaimPage extends Component {
    state = {
        loading: true,
        error: "",
        data: null,
        step: "details",
        bsb: "",
        accountNumber: "",
        code: "",
        submitting: false,
        submitMessage: "",
        contactOpen: false,
        contactName: "",
        contactEmail: "",
        contactMessage: "",
        contactSubmitting: false,
        contactStatus: ""
    }

    componentDidMount() {
        this.loadClaim()
    }

    loadClaim = async () => {
        const claimId = this.props.match.params.claimId
        try {
            const res = await fetch(API_ENDPOINT + "v2/public/claims?claimId=" + encodeURIComponent(claimId))
            const data = await res.json()
            if (!res.ok || !data.found) throw new Error(data.message || "Claim not found.")
            const claim = data.claim || {}
            const claimFailed = claim.payoutStatus === "failed"
            const claimReset = claim.payoutStatus === "reset"
            this.setState({ data, loading: false, step: claim.status === "claimed" && !claimFailed && !claimReset ? "claimed" : "details" })
        } catch (error) {
            this.setState({ error: error.message || "Claim not found.", loading: false })
        }
    }

    requestVerification = async () => {
        const claimId = this.props.match.params.claimId
        this.setState({ submitting: true, submitMessage: "" })
        try {
            const res = await fetch(API_ENDPOINT + "v2/public/claims/verification", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    claimId,
                    bsb: this.state.bsb,
                    accountNumber: this.state.accountNumber
                })
            })
            const data = await res.json().catch(() => ({}))
            if (!res.ok) throw new Error(data.message || "Verification code could not be sent.")
            this.setState({ step: "verify", submitting: false, submitMessage: "Verification code sent." })
        } catch (error) {
            this.setState({ submitting: false, submitMessage: error.message || "Verification code could not be sent." })
        }
    }

    completeClaim = async () => {
        const claimId = this.props.match.params.claimId
        this.setState({ submitting: true, submitMessage: "" })
        try {
            const res = await fetch(API_ENDPOINT + "v2/public/claims/complete", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    claimId,
                    code: this.state.code
                })
            })
            const data = await res.json().catch(() => ({}))
            if (!res.ok) throw new Error(data.message || "Prize claim could not be completed.")
            this.setState({ data, step: "claimed", submitting: false, submitMessage: "" })
        } catch (error) {
            this.setState({ submitting: false, submitMessage: error.message || "Prize claim could not be completed." })
        }
    }

    openContact = () => {
        const data = this.state.data || {}
        const claim = data.claim || {}
        this.setState({
            contactOpen: true,
            contactName: claim.name || "",
            contactEmail: claim.email || "",
            contactStatus: ""
        })
    }

    sendContact = async () => {
        const { data, contactName, contactEmail, contactMessage } = this.state
        const claimId = this.props.match.params.claimId
        const event = (data && data.event) || {}
        const org = (data && data.organisation) || {}
        const claim = (data && data.claim) || {}
        const email = contactEmail.trim()
        const message = contactMessage.trim()
        if (!message) {
            this.setState({ contactStatus: "Please enter a message." })
            return
        }
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            this.setState({ contactStatus: "Please enter an email address so we can reply." })
            return
        }

        this.setState({ contactSubmitting: true, contactStatus: "" })
        try {
            const eventTitle = event.name || event.title || "Split 50-50 raffle"
            const eventId = event.eventId || claim.eventId || ""
            const winningTicket = eventId && claim.winningTicket ? eventId + "_" + claim.winningTicket : ""
            const context = [
                "",
                "---",
                "Claim context",
                "Claim ID: " + claimId,
                eventId ? "Event ID: " + eventId : "",
                "Event: " + eventTitle,
                winningTicket ? "Winning ticket: " + winningTicket : "",
                org.orgName || org.name ? "Organisation: " + (org.orgName || org.name) : ""
            ].filter(Boolean).join("\n")
            const res = await fetch(API_ENDPOINT + "v2/support/contact", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    type: "claim_support",
                    name: contactName.trim(),
                    email,
                    organisationName: org.orgName || org.name || "",
                    clientUrl: eventId ? "claim/" + claimId : "",
                    subject: "Winner claim support request: " + eventTitle,
                    message: message + context
                })
            })
            const body = await res.json().catch(() => ({}))
            if (!res.ok) throw new Error(body.message || "Could not send your message.")
            this.setState({ contactSubmitting: false, contactStatus: "Thanks, your message has been sent.", contactMessage: "" })
        } catch (error) {
            this.setState({ contactSubmitting: false, contactStatus: error.message || "Could not send your message." })
        }
    }

    render() {
        const { loading, error, data, step, bsb, accountNumber, code, submitting, submitMessage, contactOpen, contactName, contactEmail, contactMessage, contactSubmitting, contactStatus } = this.state
        const event = (data && data.event) || {}
        const org = (data && data.organisation) || {}
        const claim = (data && data.claim) || {}
        const client = {
            name: org.orgName || org.name || "Split 50-50",
            styles: {
                logo: data && data.brand && data.brand.logoUrl,
                logoScale: data && data.brand && data.brand.logoScale,
                backgroundUrl: event.heroImageUrl || (data && data.brand && data.brand.backgroundUrl),
                logoMask: data && data.brand && data.brand.logoMask,
                logoBackgroundColor: data && data.brand && data.brand.logoBackgroundColor,
                overlayColor: event.overlayColor || (data && data.brand && data.brand.overlayColor),
                overlayOpacity: event.overlayOpacity || (data && data.brand && data.brand.overlayOpacity),
                primaryColor: data && data.brand && data.brand.primaryColor,
                secondaryColor: data && data.brand && data.brand.secondaryColor
            }
        }
        const brand = brandStyles(client, event)
        const eventTitle = event.name || event.title || "Split 50-50 raffle"
        const eventId = event.eventId || claim.eventId || ""
        const winningTicketId = eventId && claim.winningTicket ? eventId + "_" + claim.winningTicket : "the winning ticket"
        const availableAt = claim.availableAt || claim.payoutAvailableAt
        const availableTime = availableAt ? new Date(availableAt).getTime() : null
        const hasFutureAvailability = Boolean(availableAt) && !Number.isNaN(availableTime) && availableTime > Date.now()
        const canClaimNow = claim.canClaim === false ? false : !hasFutureAvailability
        const claimFailed = claim.payoutStatus === "failed"
        const claimReset = claim.payoutStatus === "reset"
        const availabilityText = claim.availableAtText || (availableAt ? drawDate(availableAt) : "")
        const availabilityMessage = canClaimNow
            ? ""
            : availabilityText
                ? "Prize funds are being processed. Please come back from " + availabilityText + " to claim your prize."
                : "Prize funds are being processed. Please allow up to 5 business days from the draw to claim your prize."
        const claimCopy = claimFailed
            ? "Your previous payout could not be completed" + (claim.payoutError ? ": " + claim.payoutError : ".") + " Please contact Split 50-50 so we can reopen your claim."
            : claimReset
                ? "Your claim has been reopened. Please enter the corrected bank account details, then verify with the SMS code sent to the winning mobile number."
                : step === "claimed"
                    ? "The prize for " + winningTicketId + " in " + eventTitle + " has been claimed successfully" + (claim.claimedAt ? " on " + drawDate(claim.claimedAt) : "") + ". Please allow up to 5 business days for the bank transfer to process."
                    : !canClaimNow
                        ? availabilityMessage
                        : claim.phoneLast4
                            ? "Enter your bank account details to claim " + winningTicketId + " for " + eventTitle + ", then verify with the SMS code sent to the winning mobile number ending in " + claim.phoneLast4 + "."
                            : "Enter your bank account details to claim " + winningTicketId + " for " + eventTitle + ", then verify with the SMS code sent to the winning mobile number."
        const canClaim = bsb.replace(/\D/g, "").length >= 6 && accountNumber.replace(/\D/g, "").length >= 6
        const canVerify = code.replace(/\D/g, "").length >= 6
        const backgroundStyle = {
            backgroundImage: brand.backgroundUrl ? "url(" + brand.backgroundUrl + ")" : undefined,
            "--v2-primary": brand.primaryColor,
            "--v2-secondary": brand.secondaryColor
        }

        return (
            <div className="v2-public-page" style={backgroundStyle}>
                <div className="v2-public-overlay" style={{ backgroundColor: brand.overlayColor, opacity: brand.overlayOpacity }} />
                <main className="v2-claim-layout">
                    {loading ? (
                        <section className="v2-claim-loading">
                            <h1>Loading claim...</h1>
                            <p>Fetching the winning ticket and payout details.</p>
                        </section>
                    ) : error ? (
                        <section className="v2-claim-loading">
                            <h1>Claim not found</h1>
                            <p className="v2-support-copy">{error}</p>
                        </section>
                    ) : (
                        <>
                            <section className="v2-claim-hero">
                                {logoNode(client, event, "v2-public-logo")}
                                <span>Winner claim portal</span>
                                <h1>Claim your prize</h1>
                                <p className="v2-public-event-id">{eventTitle}</p>
                                {eventId ? <p className="v2-claim-event-meta"><span>Event ID </span><span className="v2-event-id-value">{eventId}</span></p> : null}
                                <p className="v2-claim-ticket-id">
                                    <span className="v2-claim-ticket-label">Winning ticket </span>
                                    <span className="v2-event-id-value">{winningTicketId}</span>
                                </p>
                            </section>

                            <section className="v2-claim-side">
                                {submitMessage ? <p className="v2-claim-message">{submitMessage}</p> : null}
                                {claimFailed ? (
                                    <section className="v2-claim-card">
                                        <p className="v2-claim-card-eyebrow">Payout needs attention</p>
                                        <strong className="v2-claim-card-prize">{moneyCents(claim.prizeAmount)}</strong>
                                        <p className="v2-claim-panel-copy">{claimCopy}</p>
                                        <button className="v2-claim-contact-button" onClick={this.openContact}>Contact Split 50-50</button>
                                    </section>
                                ) : step === "claimed" ? (
                                    <section className="v2-claim-card">
                                        <p className="v2-claim-card-eyebrow">Prize amount</p>
                                        <strong className="v2-claim-card-prize">{moneyCents(claim.prizeAmount)}</strong>
                                        <p className="v2-claim-panel-copy">{claimCopy}</p>
                                        <strong>Payout submitted</strong>
                                        <span>Transaction ID {claim.transactionId || "Pending"}</span>
                                    </section>
                                ) : !canClaimNow ? (
                                    <section className="v2-claim-card">
                                        <p className="v2-claim-card-eyebrow">Prize amount</p>
                                        <strong className="v2-claim-card-prize">{moneyCents(claim.prizeAmount)}</strong>
                                        <p className="v2-claim-panel-copy">{claimCopy}</p>
                                    </section>
                                ) : step === "verify" ? (
                                    <section className="v2-claim-card">
                                        <p className="v2-claim-card-eyebrow">Prize amount</p>
                                        <strong className="v2-claim-card-prize">{moneyCents(claim.prizeAmount)}</strong>
                                        <p className="v2-claim-panel-copy">Enter the verification code sent to the winning mobile number to complete the payout.</p>
                                        <label>
                                            Verification code
                                            <input value={code} placeholder="123456" onChange={(e) => this.setState({ code: e.target.value.replace(/\D/g, "").slice(0, 6) })} />
                                        </label>
                                        <button className="v2-primary-action" disabled={!canVerify || submitting} onClick={this.completeClaim}>
                                            {submitting ? "Submitting payout..." : "Complete claim"}
                                        </button>
                                    </section>
                                ) : (
                                    <section className="v2-claim-card">
                                        <p className="v2-claim-card-eyebrow">Prize amount</p>
                                        <strong className="v2-claim-card-prize">{moneyCents(claim.prizeAmount)}</strong>
                                        <p className="v2-claim-panel-copy">{claimCopy}</p>
                                        <label>
                                            BSB
                                            <input value={bsb} placeholder="000000" onChange={(e) => this.setState({ bsb: e.target.value.replace(/\D/g, "").slice(0, 6) })} />
                                        </label>
                                        <label>
                                            Account number
                                            <input value={accountNumber} placeholder="123456789" onChange={(e) => this.setState({ accountNumber: e.target.value.replace(/\D/g, "").slice(0, 12) })} />
                                        </label>
                                        <button className="v2-primary-action" disabled={!canClaim || submitting} onClick={this.requestVerification}>
                                            {submitting ? "Sending code..." : "Send verification code"}
                                        </button>
                                    </section>
                                )}
                                <section className="v2-claim-trust-card">
                                    <strong>Secure winner verification</strong>
                                    <p>Your claim is protected with SMS two-factor verification. Bank details are submitted securely and used only to process your prize payout.</p>
                                    <button className="v2-claim-contact-button" onClick={this.openContact}>Contact Split 50-50</button>
                                </section>
                            </section>
                            <V2PoweredBy className="v2-claim-page-powered" />
                            {contactOpen ? (
                                <div className="v2-modal-shell">
                                    <div className="v2-modal-card v2-claim-contact-modal">
                                        <button className="v2-modal-close" onClick={() => this.setState({ contactOpen: false })}>×</button>
                                        <p className="v2-modal-eyebrow">Winner support</p>
                                        <h2>Need help with your claim?</h2>
                                        <p className="v2-claim-contact-copy">Send us your question and the Split 50-50 team will come back to you.</p>
                                        {contactStatus ? <p className="v2-claim-message">{contactStatus}</p> : null}
                                        <label>
                                            Name
                                            <input value={contactName} onChange={(e) => this.setState({ contactName: e.target.value })} placeholder="Your name" />
                                        </label>
                                        <label>
                                            Email
                                            <input value={contactEmail} onChange={(e) => this.setState({ contactEmail: e.target.value })} placeholder="you@example.com" />
                                        </label>
                                        <label>
                                            How can we help?
                                            <textarea value={contactMessage} onChange={(e) => this.setState({ contactMessage: e.target.value })} placeholder="Type your question here" rows="5" />
                                        </label>
                                        <div className="v2-claim-contact-actions">
                                            <button className="v2-claim-contact-button v2-claim-contact-button--light" onClick={() => this.setState({ contactOpen: false })} disabled={contactSubmitting}>Cancel</button>
                                            <button className="v2-primary-action" onClick={this.sendContact} disabled={contactSubmitting || !contactMessage.trim()}>
                                                {contactSubmitting ? "Sending..." : "Send message"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </>
                    )}
                </main>
            </div>
        )
    }
}

export default V2ClaimPage
